export const DIAGNOSTICS_POLL_VISIBLE_MS = 12000;
export const DIAGNOSTICS_POLL_HIDDEN_MS = 60000;

export function diagnosticsPollIntervalMs(visible: boolean): number {
  return visible ? DIAGNOSTICS_POLL_VISIBLE_MS : DIAGNOSTICS_POLL_HIDDEN_MS;
}
